import { toast } from '@/shared/utils/UIHelper'
import AuthRepository from '@/shared/http/repositories/access/auth.js'
export default {
  name: 'ChangePassword',
  data () {
    return {
      version: process.env.VersionApp,
      token: null,
      password: null,
      confirmation: null,
      link: null
    }
  },
  mounted () {
    this.token = this.$route.params.token
  },
  methods: {
    onResetPassword () {
      if (this.password.length < 6) {
        toast.error('Senha deve conter no mínimo 6 caractéres!')
      } else {
        AuthRepository.ResetEmailSenha({token: this.token, Password: this.password})
          .then(Response => {
            toast.success('Senha alterada com sucesso!')
          })
          .catch(() => {
            toast.error(`Erro ao salvar mudanças`)
          })
      }
    }
  }

}

// const UrlParams = new URLSearchParams(window.location.search);
// const token = UrlParams.get("t");
// this.dataNewPassWord.token = token.split("?Login=")[0]
// this.dataNewPassWord.email = token.split("?Login=")[1];
// this.dataNewPassWord.email = this.dataNewPassWord.email.trim();



// WEBPACK FOOTER //
// ./src/views/public/password/change/ChangePassword.js